import React from 'react';
import './App.css';

function App() {
  const documentos = [
    { nome: 'Atividades Individuais - World Café', caminho: '/d1.pdf' },
    { nome: 'E-Book - Projetos Literários - Com quantas asas', caminho: '/d2.pdf' },
    { nome: 'Entrelinhas - Com quantas asas se faz um cachorro - Educador', caminho: '/d3.pdf' },
    { nome: 'Itinerários - Atividade World Café ', caminho: '/d4.pdf' },
    { nome: 'Mobilização de Leitura - Atividade World Café', caminho: '/d5.pdf' },
  ];

  return (
    <div className="App">
      <h1>Evento - Mediadores de Leitura</h1>
      <div className="links-container">
        {documentos.map((doc, index) => (
          <a
            key={index}
            href={doc.caminho}
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-link"
          >
            {doc.nome}
          </a>
        ))}
      </div>
    </div>
  );
}

export default App;